export default __webpack_public_path__ + "static/bumble-c397aeb5e1f9719bbccfa66a505bc7de.png";